export function gridFields() {
    return Object.freeze([
    {
      key: 'id',
      label: 'lbl.processMaterial.id',
      uneditable: true,
      notInTable: true,
      sortable: true,
      form: {
        type: 'input'
      }
    },
    {
      key: 'optionId',
      label: 'lbl.processMaterial.optionId',
      notInTable: true,
      uneditable: true,
      sortable: true,
      form: {
        type: 'dimSearch',
        url: process.env.VUE_APP_MASTER_API_URL + 'master-service/master/processOption/findAll',
        config: {
          validate: "", // 参数检查，可以是正则表达式等
          bindId: 'processOption', // 绑定的 id, (id 相同的对象会被绑定)
          bindProp: "id", // 显示的属性的名称
          submitProp: "id" // 提交的属性
        }
      }
    },
    {
      key: 'optionName',
      label: 'lbl.processMaterial.optionName',  
      filterable: true, 
      sortable: true,
      required: true,
      form: {
        type: 'dimSearch',
        url: process.env.VUE_APP_MASTER_API_URL + 'master-service/master/processOption/findAll',
        config: {
          validate: "", // 参数检查，可以是正则表达式等
          bindId: 'processOption', // 绑定的 id, (id 相同的对象会被绑定)
          bindProp: "name", // 显示的属性的名称
          submitProp: "name" // 提交的属性
        }
      }
    },
    
    {
      key: 'materialId',
      label: 'lbl.processMaterial.materialId',     
      notInTable: true,
      uneditable: true,
      form: {
        type: 'dimSearch',
        url: process.env.VUE_APP_MASTER_API_URL + 'master-service/master/material/findAll',
        config: {
          validate: "", // 参数检查，可以是正则表达式等
          bindId: 'processMaterial', // 绑定的 id, (id 相同的对象会被绑定)
          bindProp: "id", // 显示的属性的名称
          submitProp: "id" // 提交的属性
        }
      }
    },
    {
      key: 'materialCode',
      label: 'lbl.processMaterial.materialCode',     
      sortable: true, 
      required: true,
      form: {
        type: 'dimSearch',
        url: process.env.VUE_APP_MASTER_API_URL + 'master-service/master/material/findAll',
        config: {
          validate: "", // 参数检查，可以是正则表达式等
          bindId: 'processMaterial', // 绑定的 id, (id 相同的对象会被绑定)
          bindProp: "matCode", // 显示的属性的名称
          submitProp: "matCode" // 提交的属性
        }
      }
    },
    
    {
      key: 'materialName',
      label: 'lbl.processMaterial.materialName',
      sortable: true, 
      required: true,      
      form: {
        type: 'dimSearch',
        url: process.env.VUE_APP_MASTER_API_URL + 'master-service/master/material/findAll',
        config: {
          validate: "", // 参数检查，可以是正则表达式等
          bindId: 'processMaterial', // 绑定的 id, (id 相同的对象会被绑定)
          bindProp: "matName", // 显示的属性的名称
          submitProp: "matName" // 提交的属性
        }
      }
    },
    {
      key: 'materialType',
      label: 'lbl.processMaterial.type',
      sortable: true,
      form: {
        type: 'select',
          options: [         
            { value: 'R', text:  'lbl.processMaterial.R' },  
            { value: 'P', text:  'lbl.processMaterial.P' }                                
          ]  
      }
    },
    {
      key: 'materialUnit',
      label: 'lbl.processMaterial.unit',
      form: {
        type: 'input'          
      }
    },
    {
      key: 'materialPercent',
      label: 'lbl.processMaterial.percent',
      form: {
        type: 'input'          
      }
    }
    ]);
  }
  
  function nextYear() {
    const current = new Date;
    return new Date(current.getFullYear() + 1, current.getMonth(), current.getDate())
  }
  
  // class
  export const ProcessMaterial = function () {
    gridFields().forEach(item => {
      this[item.key] = item.default || '';
    })
  }
  
  
  export const filter = gridFields()
    .filter(v => v.filterable)
    .reduce((tar, v) => {
      tar[`${v.key}Filter`] = v.default || '';
      return tar
    }, {})
  export const filterFields = gridFields().filter(v => v.filterable).map(v => `filter.${v.key}`)